function forcePositiveInteger(value) {
  return value.replace(/\D+/g, '');
}

export { forcePositiveInteger };
